import { ChartType, ChartTypeOption } from '..';

export const CHART_TYPES_NEEDING_ORPHAN_HANDLING: ChartTypeOption[] = [
  ChartType.LINE,
  ChartType.AREA,
  ChartType.SPLINE,
  ChartType.AREA_SPLINE,
  ChartType.AREA_RANGE,
];

/**
 * Checks whether orphans for a Highcharts chart should be shown based on the Highcharts configuration
 * For now, only using highchartsConfig.chart.type
 * @param series series object (name, data, optional type)
 * @param highchartsConfig Highcharts configuration
 * @returns boolean determining whether orphans should be shown
 */
export const shouldHandleOrphans = (series: Record<string, any>, highchartsConfig?: Record<string, any>): boolean => {
  const chartType = series.type ?? highchartsConfig?.chart?.type ?? ChartType.LINE;
  return chartType && CHART_TYPES_NEEDING_ORPHAN_HANDLING.includes(chartType);
};
